module.exports = __webpack_public_path__ + "img/lock_image.5b3e50b0.png";